import { node } from 'prop-types'
import { Outlet, useLocation } from 'react-router-dom'
import { Header, Segment } from 'semantic-ui-react'
import SecondaryMenu from '../../components/SecondaryMenu'
import Layout from '../Layout'
import './Alerts.scss'

function Alerts() {
  const location = useLocation()
  return (
    <Layout>
      <div className='physics_header'>
        <Header as='h1'>Solar burst alert system</Header>
      </div>
      <div className='physics_body'>
        <div className='left_panel'>
          <SecondaryMenu
            items={[
              {
                name: 'General information',
                link: 'general',
                icon: 'note',
              },
              {
                name: 'User form',
                link: 'form',
                icon: 'sun',
              },
            ]}
            activeItem={location.pathname.split('/')[2]}
          />
        </div>
        <Segment className='right_panel'>
          <Outlet />
        </Segment>
      </div>
    </Layout>
  )
}

Alerts.propTypes = {
  children: node,
}

export default Alerts
